import { useState } from "react";
import { X } from "lucide-react";
import { Input } from "@/components/ui/input";

export const SkillsInput = ({ value, onChange, placeholder = "Type a skill and press Enter", testid = "skills" }) => {
  const [draft, setDraft] = useState("");
  const add = () => {
    const parts = draft.split(",").map((s) => s.trim()).filter(Boolean);
    if (parts.length) onChange([...new Set([...(value || []), ...parts])]);
    setDraft("");
  };
  return (
    <div>
      <div className="mb-2 flex flex-wrap gap-2 empty:hidden" data-testid={`${testid}-list`}>
        {(value || []).map((s) => (
          <span key={s} className="inline-flex items-center gap-1 rounded-full border border-[#D4AF37]/30 bg-[#D4AF37]/10 px-3 py-1 text-xs text-[#F3C649]">
            {s}
            <button type="button" onClick={() => onChange(value.filter((x) => x !== s))} data-testid={`remove-${testid}-${s}`}><X className="h-3 w-3" /></button>
          </span>
        ))}
      </div>
      <Input value={draft} onChange={(e) => setDraft(e.target.value)} placeholder={placeholder}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(); } }} onBlur={add}
        className="bg-[#09090B]" data-testid={`${testid}-input`} />
    </div>
  );
};
